import { removeFromLocalStorage, saveToLocalStorage } from "pianofunclub-crm/utils/localStorage";

export const saveAuthInfoToLocalStorage = (variables: {
  accountType: string | null | undefined;
  refreshToken: string | null | undefined;
  refreshTokenExpiresAt: number | null | undefined;
  token: string;
  tokenExpiresAt: number | null | undefined;
}) => {
  saveToLocalStorage("token", variables.token);
  saveToLocalStorage("token_expires_at", variables.tokenExpiresAt?.toString() ?? "");
  saveToLocalStorage("refresh_token_expires_at", variables.refreshTokenExpiresAt?.toString() ?? "");
  saveToLocalStorage("refresh_token", variables.refreshToken ?? "");
  saveToLocalStorage("account_type", variables.accountType ?? "");
};

export const removeAuthInfoFromLocalStorage = () => {
  removeFromLocalStorage("token");
  removeFromLocalStorage("token_expires_at");
  removeFromLocalStorage("refresh_token");
  removeFromLocalStorage("refresh_token_expires_at");
  removeFromLocalStorage("account_type");
};
